import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered"},[_c('enough-tokens',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var disabled = ref.disabled;
return [_c(VBtn,{attrs:{"loading":_vm.loading,"disabled":disabled,"color":"primary","large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t("TriCaster.buttons.launch"))+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }